export default __webpack_public_path__ + "static/media/anne-nagle.b924f4c7.jpg";